import { Timeline, TimelineState } from "@xzdarcy/react-timeline-editor";
import { cloneDeep } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Slider,
  Stack,
  ToggleButton,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { TimelineRow } from "@xzdarcy/react-timeline-editor";
import {
  ChangeEditMode,
  GetAudioState,
  GetAutoScroll,
  GetEditMode,
  GetFetchingVideoFileData,
  GetFps,
  GetHandleAudio,
  GetInFrame,
  GetLinkedToPreviewActionId,
  GetOutFrame,
  GetTimelineActions,
  GetZoomState,
  SetAudioState,
  SetShowSequence,
  SetTimelineActions,
  ToggleAutoScroll,
  calculateNextTimelineState,
} from "../../Redux/Reducers/redux-slice-timetool";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import { CustomTimelineAction } from "./custom-timeline-action";
import { CusTomTimelineRow } from "./custom-timeline-row";
import TimelinePlayer, { mockEffect } from "./Timeline-player";
import { TimelineAction } from "./Timeline-action";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import GpsNotFixedIcon from "@mui/icons-material/GpsNotFixed";
import { SequenceMetadataSegment } from "../../Core/Api/Types/sequence-metadata-segment";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { useTranslation } from "react-i18next";

export const Rates = [0.2, 0.5, 1.0, 1.5, 2.0];
export const startLeft = 20;

const SCISSORS_SVG =
  "data:image/x-icon;base64,AAACAAEAICAAAAAAAACoEAAAFgAAACgAAAAgAAAAQAAAAAEAIAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3PEkBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAgIFAgIDSgwNEHkPERRREBMXBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMDBWsmLDfjLjQ/ZB0gJ2kYHCSaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKFRcdzTQ5RVYAAAAAAAAAAAgKDosaICg7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQwjKC/bLzQ9GAAAAAAAAAAABAUGgh0jLWAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQICAhUZHrIxNj5aDg8SAgEBASkRExjRIicwJQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABgcIdGJve/UmKjK8HiEpwSQnL5MhJS0IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBAQEFBgiRc3+K3EpTYD4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQECICkrMd9WXWdJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBAQMGBgiMR05ZwgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQEBQjU5Qe9KUVtAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMDBBYRERXJaXF8ywAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBAgICAgMrBwgKRgsNEBkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGBwgHHiEklXaCkv1SWmd8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBAwQFYCcsNs0qLjdwHB4lmhwgJ10AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwMDBw4PEXSQnav3iZal/kxTX3YAAAAAAAAAAAAAAAAAAAAAAAAAAAEBATgmKzTiNz9KJgAAAAAICQseMzpE6yYrMqoWGBx4Dg8TIQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAgINAgICNggJC34ZGyHEVlxo9mlxff59iJX+ZG168zQ4P6kQEhZoCQkMUAcHCVQFBgiCKi41311od+0AAAAAAAAAAAEBAjcwNT/sQUhVTyAkKwgXGSBSFxkfBQAAAAAAAAAAAAAAAAAAAAAAAAAAAQECAQECAhYDAwROCwsPlhsdJdMsLzv3QEZT/mt1g/5hbHv+XWd2/l1mc/xZY3HfXmh3tVdfbphCSlayTlhl2ktTYHxDSVROLjM9kxseJHAFBgdJFBUZxDE2QHcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQICEwMEBVMNDxOkHSAo4ScrOfwqLz3+LDE+/isxPf4zOUb+TVRi/m55iPVRWWdoS1NgFgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVFxwBHyIpTjA1QJMwNEBZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQICJgoLDowcHybbJSkz+SQqNeAcIi62HiItjh0hK2IRFBlLLzM6yJShrf6VorHse4aWOgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKCw83Gh0nUiEkLiwkKDIKAAAAAAAAAAAAAAAACgsODBocH6KAipf8jJik5H+JlywAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQEBQYREhWLcnuH+n6GldZ3f40iAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAwMCCQkLcmFodPZweITCbHOBEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQFBlJKT1nwYWh0pmJqdgYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAwQoLzI611NYZYMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQICBxUXG444PEZLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGRshDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA///////////////////////////////////b////u////7v///+7////w////5////+/////P////3////5////8/1///P7n//A47/8ABt/4A/+/wMf///+P////H////z////5////8////+/////////////////////////8=";

const TimelineEditor: React.FC<{
  onGenerated: (segments: SequenceMetadataSegment[]) => void;
}> = ({ onGenerated }) => {
  const { t } = useTranslation();
  const data = useSelector(GetTimelineActions);
  const [localData, setLocalData] = useState<CusTomTimelineRow[]>(data);
  const timelineState = useRef<TimelineState | null>(null);
  const autoScrollWhenPlay = useRef<boolean>(true);
  const linkedAction = useSelector(GetLinkedToPreviewActionId);
  const fps = useSelector(GetFps);
  const editionMode = useSelector(GetEditMode);
  const dispatch = useDispatch();
  const [focusActionId, setFocusActionId] = useState<string>("");
  const inFrame = useSelector(GetInFrame);
  const outFrame = useSelector(GetOutFrame);
  const zoomState = useSelector(GetZoomState);
  const autoScroll = useSelector(GetAutoScroll);
  const audioState = useSelector(GetAudioState);
  const handleAudio = useSelector(GetHandleAudio);
  const fetchingVideoFileData = useSelector(GetFetchingVideoFileData);
  const [dataWithAudioTracks, setDataWIthAudioTracks] = useState<CusTomTimelineRow[]>([]);

  const theme = useTheme();
  const domRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setLocalData(data);
    if (data && !handleAudio) {
      setDataWIthAudioTracks([...data]);
      return;
    }
    if (data && handleAudio) {
      const dataWithAudio: CusTomTimelineRow[] = [];
      let id = 0;
      for (let i = 0; i < data.length; i++) {
        dataWithAudio.push({ ...data[i] });
        id += 1;
        let maxTracksCount = 0;
        data[i].actions.forEach((x, i) => {
          const audioMap = x.data.audioMapping;
          if (audioMap && audioMap.length > maxTracksCount) maxTracksCount = audioMap?.length ?? 0;
        });

        for (let n = 0; n < maxTracksCount; n++) {
          let newAudioTrackRow: CusTomTimelineRow = {
            isAudio: true,
            actions: [],
            id: id.toString(),
            trackIndex: n,
          };
          data[i].actions.forEach((x) => {
            let trackCOunt = x.data.audioMapping?.length ?? 0;

            if (trackCOunt && trackCOunt > n && x.data.audioMapping) {
              newAudioTrackRow.actions.push({
                ...x,
                data: {
                  ...x.data,
                  audioTrackIndex: Math.trunc(n / 2),
                  channel: n % 2,
                  audioTrackInfos: x.data.audioMapping[n],
                },
              });
            }
          });

          dataWithAudio.push(newAudioTrackRow);
          id += 1;
        }
      }
      setDataWIthAudioTracks(dataWithAudio);
      dispatch(SetShowSequence(true));
    }
  }, [data, handleAudio]);

  const [verticalScale, setvarticalScale] = useState(70);
  const handleVerticalSliderZoom = (e) => {
    setvarticalScale(e.target.value);
  };

  const LeftTimelineAreaMemo = useMemo(
    () => (
      <div
        ref={domRef}
        style={{
          overflow: "overlay",
          width: "150px",
          marginTop: "42px",
          height: "100%",
          flex: "0 1  auto",
          padding: "0 10px",
          paddingBottom: theme.spacing(1.5),
        }}
        onScroll={(e) => {
          const target = e.target as HTMLDivElement;
          timelineState.current && timelineState.current.setScrollTop(target.scrollTop);
        }}
        className={"timeline-list"}
      >
        {[
          ...dataWithAudioTracks,
          { id: dataWithAudioTracks.length.toString(), actions: [] },
          { id: (dataWithAudioTracks.length + 1).toString(), actions: [] },
        ].map((item, index) => {
          return (
            <div
              style={{
                height: `${verticalScale}px`,
                padding: "2px",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                opacity: index === dataWithAudioTracks.length || index === dataWithAudioTracks.length + 1 ? 0 : 1,
              }}
              className="timeline-list-item"
              key={item.id}
            >
              <div
                style={{
                  height: `${verticalScale * 0.9}px`,
                  width: "100%",
                  paddingLeft: "10px",
                  borderRadius: "4px",
                  borderTopRightRadius: item.isAudio ? 0 : "4px",
                  borderBottomRightRadius: item.isAudio ? 0 : "4px",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#333",
                  fontSize: "12px",
                }}
                className="text"
              >
                {item.isAudio ? `Audio Tr. ${(item.trackIndex ?? 0) + 1}` : `Track ${parseFloat(item.id) + 1}`}
              </div>
              {item.isAudio && (
                <Stack height={`${verticalScale * 0.9}px`} direction={"column"}>
                  <Button
                    sx={{ height: `${verticalScale * 0.9}px`, borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                    variant="outlined"
                    color={audioState.trackIndex === item.trackIndex ? "success" : "primary"}
                    onClick={() => {
                      dispatch(SetAudioState({ selectedChannels: "both", trackIndex: item.trackIndex }));
                    }}
                  >
                    <VolumeUpIcon />
                  </Button>
                </Stack>
              )}
            </div>
          );
        })}
      </div>
    ),
    [dataWithAudioTracks, verticalScale, audioState]
  );

  const LeftTimelineControlsMemo = useMemo(
    () => (
      <Stack
        sx={{ backgroundColor: theme.palette.background[200] }}
        direction="column"
        width="40px"
        display="flex"
        height="100%"
      >
        <Tooltip title={t("tooltip:title.cutClip")}>
          <ToggleButton
            onClick={(e) => dispatch(ChangeEditMode(editionMode === "cut" ? "default" : "cut"))}
            sx={{
              opacity: 0.7,
              ml: 1,
              mr: 1,
              mt: 1,
              mb: 2,
            }}
            value=""
          >
            <ContentCutIcon color={editionMode === "cut" ? "primary" : "inherit"} />
          </ToggleButton>
        </Tooltip>
        <Tooltip title={t("tooltip:title.trackCursor")}>
          <ToggleButton
            onClick={(e) => dispatch(ToggleAutoScroll())}
            sx={{
              opacity: 0.7,
              ml: 1,
              mr: 1,
              mt: 1,
              mb: 2,
            }}
            value=""
          >
            {autoScroll ? <GpsFixedIcon color="primary" /> : <GpsNotFixedIcon />}
          </ToggleButton>
        </Tooltip>
        <Box>
          <ZoomInIcon sx={{ opacity: 0.7, ml: 1.2, mr: 1, mt: 1, color: theme.palette.grey[500] }} />
          <Slider
            sx={{ opacity: 0.7, height: "6vw", marginLeft: "5px" }}
            size="small"
            step={1}
            min={10}
            orientation="vertical"
            max={200}
            defaultValue={verticalScale}
            aria-label="Default"
            valueLabelDisplay="off"
            onChange={handleVerticalSliderZoom}
          />
          <ZoomOutIcon sx={{ opacity: 0.7, ml: 1.2, mr: 1, mt: 0.5, color: theme.palette.grey[500] }} />
        </Box>
      </Stack>
    ),
    [editionMode, autoScroll]
  );

  const TimelineControlsMemo = useMemo(
    () => (
      <TimelinePlayer
        autoScrollWhenPlay={autoScrollWhenPlay}
        timelineState={timelineState}
        timelineScale={zoomState.scale}
        timelineWidth={zoomState.width}
        onGenerated={onGenerated}
      />
    ),
    [zoomState.scale, zoomState.width, autoScroll]
  );

  return (
    <div
      style={{
        zIndex: 100000000,
        width: "100vw",
        maxWidth: "100vw",
        height: "100%",
      }}
    >
      {TimelineControlsMemo}

      <div
        style={{ display: "flex", width: "100%", backgroundColor: "#191b1d", height: "100%" }}
        className="timeline-editor-example7"
      >
        {LeftTimelineControlsMemo}
        {LeftTimelineAreaMemo}
        <Timeline
          dragLine
          style={{
            filter: fetchingVideoFileData ? "blur(4px)" : "blur(0px)",
            overflowY: "scroll",
            width: "100vw",
            maxWidth: "100vw",
            height: "calc(100% + 42px)",
            paddingBottom: theme.spacing(1.5),
            backgroundColor: theme.palette.background.paper,
            cursor: editionMode === "cut" ? `url(${SCISSORS_SVG}), auto` : "inherit",
            fontFamily: "Inter, Helvetica Neue, Arial, sans-serif",
          }}
          scale={zoomState.scale}
          scaleWidth={zoomState.width}
          startLeft={startLeft}
          minScaleCount={9999}
          autoScroll={true}
          ref={timelineState}
          onClickActionOnly={(e, param) => {
            setFocusActionId(param.action.id);
          }}
          editorData={
            cloneDeep([
              ...dataWithAudioTracks,
              {
                id: dataWithAudioTracks.length.toString(),
                actions: [],
              },
              {
                id: (dataWithAudioTracks.length + 1).toString(),
                actions: [],
              },
            ]) as TimelineRow[]
          }
          getScaleRender={(scale) => (zoomState.scale > 60 ? scale / 60 : scale.toString() + "s")}
          effects={mockEffect}
          onChange={(data) => {
            const newData =
              editionMode === "cut"
                ? calculateNextTimelineState([...localData], cloneDeep([...localData]) as CusTomTimelineRow[], fps)
                : calculateNextTimelineState(
                    [...localData],
                    data.filter((x) => !(x as CusTomTimelineRow).isAudio).slice(0, -2) as CusTomTimelineRow[],
                    fps
                  );
            dispatch(SetTimelineActions(newData));
            setLocalData(newData as CusTomTimelineRow[]);
          }}
          rowHeight={verticalScale}
          getActionRender={(action, row) => (
            <TimelineAction
              setFocusActionId={setFocusActionId}
              focus={action.id === focusActionId}
              action={action as CustomTimelineAction}
              row={row as CusTomTimelineRow}
              selected={action.id === linkedAction}
              timelineScale={zoomState.scale}
              timelineWidth={zoomState.width}
              inFrame={inFrame}
              outFrame={outFrame}
              verticalScale={verticalScale}
            />
          )}
          onScroll={({ scrollTop }) => {
            if (domRef.current) domRef.current.scrollTop = scrollTop;
          }}
        />
        {fetchingVideoFileData && (
          <Box
            sx={{
              position: "absolute",
              top: "40%",
              left: "43%",
              display: "flex",
              flexDirection: "row",
              height: "75px",
              alignContent: "center",
              alignItems: "center",
              backgroundColor: theme.palette.background.default,
              borderRadius: "5px",
              border: `1px solid ${theme.palette.primary.alphaHover}`,
              m: 1,
              p: 1,
            }}
          >
            <CircularProgress sx={{ mr: 2 }} />
            <Typography color={"text.tier"}>{t("page:body.fetchingVideoFileData")}</Typography>
          </Box>
        )}
      </div>
    </div>
  );
};

export default TimelineEditor;
